import React from "react";
import "./App.css";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import store from "./store";
import { Provider } from "react-redux";

//importing component for website
import FeedComponent from "./components/website/FeedComponent.js";
import FeedComponentForEM from "./components/website/FeedComponentForEM";
import FeedComponentUsers from "./components/website/FeedComponentUsers";
import FeedComponentForTeacher from "./components/website/FeedComponentForTeacher";
import MainTab from "./components/teacherComponents/TeacherTabs/MainTab";
import SideBar from "./components/SideBar";
import Subroutes from "./components/website/Subroutes";
import IncompleteRegistration from "./components/educationMamaComponents/IncompleteRegistration/IncompleteRegistration";
import LeadLogs from "./components/educationMamaComponents/Leads/LeadLogs";
import InvoiceDesign from "./components/website/InvoiceDesign";
import TeacherPipeline from "./components/educationMamaComponents/TeacherPipeline/TeacherPipeline";
import Test from "./TestingComponent/Test";
import AllStudents from "./components/educationMamaComponents/AllStudents/AllStudents";
import StudentDetails from "./components/educationMamaComponents/StudentDetails/StudentDetails";
import ReferralStudents from "./components/educationMamaComponents/Referral/ReferralStudents";
import RecruitmentProcess from "./components/educationMamaComponents/RecruitmentProcess/RecruitmentProcess";
import StudentInvoiceView from "./components/website/StudentInvoiceView.js";
import { StripeProvider } from "./StripeContext.js";

function App(props) {
  return (
    <Provider store={store}>
      <StripeProvider>
        <Router>
          <div className="App">
            <Switch>
              <Route exact path="/" component={FeedComponentUsers} />
              <Route path="/removeCache" component={Test} />
              <Route path="/SideBar" component={Subroutes} />
              <Route path="/dashboard" component={FeedComponentForEM} />
              <Route path="/InvoiceDesign" component={InvoiceDesign} />
              <Route
                path="/dashboards/IncompleteRegistration"
                component={IncompleteRegistration}
              />
              <Route path="/dashboards/AllStudents" component={AllStudents} />
              <Route
                path="/dashboards/ReferralStudents"
                component={ReferralStudents}
              />
              <Route
                path="/dashboards/StudentDetails/:id"
                component={StudentDetails}
              />
              <Route
                path="/dashboards/TeacherPipeline"
                component={TeacherPipeline}
              />
              <Route path="/dashboards/LeadLogs" component={LeadLogs} />
              <Route
                path="/dashboards/TeacherRecruitment"
                component={RecruitmentProcess}
              />
              <Route
                path="/Teacherdashboard"
                component={FeedComponentForTeacher}
              />
              {/* <Route
              path="/Teacherdashboard/ongoingclass"
              component={MainTab}
            /> */}
              <Route
                path="/:kidId/invoices/:token?"
                component={StudentInvoiceView}
              />
              <Route path="/:kidId/:feedId?" component={FeedComponent} />
              <Route path="/:kidId" component={FeedComponent} />
              {/* <Route
              exact
              path={componentToShow == "Student" ? "/:kidId" : "/"}
              component={
                componentToShow == "Student"
                  ? FeedComponent
                  : FeedComponentUsers
              }
            /> */}
              {/* <Route
              exact
              path="/"
              component={
                !validateIfTeacher() ? FeedComponent : FeedComponentForTeacher
              }
            /> */}
              {/* <Route exact path="/:kidId" component={FeedComponent} /> */}
            </Switch>
          </div>
        </Router>
      </StripeProvider>
    </Provider>
  );
}

export default App;
